(function () {
  if (!document.body) return;

  var hero = document.querySelector('[id^="VaultHomeHero-"].vault-home-hero');
  if (!hero) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var community = document.querySelector('[id^="VaultHomeGuides-"] .vault-home-community');
  var productImages = Array.prototype.slice.call(document.querySelectorAll('[id*="featured-collection"] img')).slice(0, 10);
  var ticking = false;

  document.body.classList.add('vod-home-awe-ready');
  productImages.forEach(function (image) {
    image.loading = 'eager';
    image.decoding = 'async';
  });

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function paint() {
    ticking = false;
    if (reduceMotion) return;

    var rect = hero.getBoundingClientRect();
    var shift = clamp(-rect.top * 0.07, -22, 22);
    hero.style.setProperty('--vod-home-parallax', shift.toFixed(2) + 'px');

    if (community) {
      var communityRect = community.getBoundingClientRect();
      var progress = 1 - clamp(communityRect.top / window.innerHeight, 0, 1);
      community.style.setProperty('--vod-sheen', (-90 + progress * 180).toFixed(2) + '%');
    }
  }

  function requestPaint() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(paint);
  }

  window.addEventListener('scroll', requestPaint, { passive: true });
  window.addEventListener('resize', requestPaint);
  requestPaint();
}());
